export const getCurrentDate = () => {
    // Generate a time string which preserves the timezone
    // We will need to handle timezone while displaying those times
    // TODO: UNIV-1329, Add time zone support for time
    return new Date().toISOString();
};
